import styled from 'styled-components';

export const WrapperDialog = styled.div<{
  show?: boolean;
  zIndex?: number;
}>`
  position: fixed;
  z-index: ${(prop) => prop.zIndex};
  top: 0;
  left: 0;
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(prop) => (prop.show ? '1' : '0')};
  visibility: ${(prop) => (prop.show ? 'visible' : 'hidden')};
  transition: opacity 0.4s ease, visibility 0.4s ease;
  background-color: rgba(40, 48, 68, 0.6);

  @media (min-width: 992px) {
    width: 100% !important;
  }
`;

export const WrapperDialogContent = styled.div<{
  maxWidth?: string;
  show?: boolean;
}>`
  position: relative;
  padding-top: 56px;
  max-height: calc(100% - 48px);
  width: calc(100% - 48px);
  max-width: ${(prop) => prop.maxWidth};
  border-radius: 8px;
  opacity: ${(prop) => (prop.show ? '1' : '0')};
  visibility: ${(prop) => (prop.show ? 'visible' : 'hidden')};
  overflow-y: auto;
  background-color: #ffffff;
`;

export const WrapperDialogClose = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  height: 40px;
  width: 40px;
  border-radius: 4px;
  transition: background-color 0.4s ease;
  background-color: #ffffff;

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    height: 2px;
    width: 16px;
    border-radius: 8px;
    background-color: #fc4a61;
  }

  &::before {
    transform: translate(-50%, -50%) rotate(45deg);
  }

  &::after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }

  &:hover {
    background-color: #fed4d6;
  }

  &:focus,
  &:active {
    background-color: #fdadb3;
  }
`;

export const WrapperDialogAction = styled.div`
  user-select: none;
  padding: 40px 32px 32px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;

export const WrapperDialogButtonA = styled.button`
  width: 100%;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 700;
  border: 1px solid #5b36f2;
  border-radius: 4px;
  color: #ffffff;
  background-color: #5b36f2;

  &:hover {
    background-color: #745ef6;
  }

  &:focus,
  &:active {
    background-color: #4318cd;
  }

  @media (min-width: 768px) {
    width: max-content;
  }
`;

export const WrapperDialogButtonB = styled.button`
  width: 100%;
  padding: 10px 24px;
  font-size: 14px;
  font-weight: 700;
  border: 1px solid #5b36f2;
  border-radius: 4px;
  color: #5b36f2;
  background-color: #ffffff;

  &:hover {
    background-color: #e2dffd;
  }

  &:focus,
  &:active {
    background-color: #c6c0fc;
  }

  @media (min-width: 768px) {
    width: max-content;
  }
`;

export const WrapperExtraCaption = styled.div`
  padding: 0 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;

  @media (max-width: 768px) {
    padding: 0 32px;
  }

  > span {
    display: block;
    text-align: center;
    color: #161d1f;

    &:nth-of-type(1) {
      font-size: 20px;
      font-weight: 900;
      line-height: 32px;
    }

    &:nth-of-type(2) {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
    }
  }

  & a {
    border-radius: 3px;
    color: #5b36f2;
    cursor: pointer;
    text-underline-offset: 3px;
    font-weight: 400;
    text-decoration: underline;
    &:hover {
      font-weight: 700;
    }
  }
`;

export const WrapperExtraImage = styled.div`
  padding: 0 32px 16px 32px;

  > img {
    margin: 0 auto;
    display: block;
  }
`;
